import { useState } from "react";
import Card from "../Reusable/Card";
import Button from "../Reusable/Button";
import toggleInputType from "../../assets/toggleInputType.png";
import copyIcon from "../../assets/copyIcon.png"; // Add your copy icon image
import copiedIcon from "../../assets/copiedIcon.png"; // Add an icon fo
import APIS from "../../constant/EndPoint";
import UnControlSwitch from "../Reusable/UnControlSwitch";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const APIIntegration = (props: any) => {
  const { profile } = props;
  const { data: apiData } = useGetHook({
    queryKey: [`merchant-api-${profile?.user.id}`],
    url: APIS.API_KEY,
    params: {
      user: profile?.user,
    },
  });

  const { mutateAsync: createNewAPI, isPostLoading } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const { mutateAsync: toggleIsActive } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const { mutateAsync: toggleIsTest } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const handleCreateNewAPI = async (values: any) => {
    const url = APIS.API_KEY;
    let formData = {
      user: profile.user,
    };
    try {
      await createNewAPI({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleIsActive = async (values: any) => {
    const url = `${APIS.API_KEY}toggle-is-active/?user=${profile.user}`;
    let formData = {};
    try {
      await toggleIsActive({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleIsTest = async (values: any) => {
    const url = `${APIS.API_KEY}toggle-is-test/?user=${profile.user}`;
    let formData = {};
    try {
      await toggleIsTest({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const handleCopy = (text: string, setCopied: (value: boolean) => void) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    }).catch(err => {
      console.error("Failed to copy: ", err);
    });
  };

  const [isPasswordType, setIsPasswordType] = useState(true);
  const [isPasswordType2, setIsPasswordType2] = useState(true);
  const [isCopiedAccessKey, setIsCopiedAccessKey] = useState(false);
  const [isCopiedSecretKey, setIsCopiedSecretKey] = useState(false);

  return (
    <>
      <Card title={"API KEY"}>
        <div className={tw`m-2`}>
          <div
            className={tw`w-full text-left relative mt-4 grid md:grid-cols-2 gap-x-4`}
          >
            <div className={tw`relative`}>
              <p>Access Key</p>
              <input
                defaultValue={apiData?.access_key}
                type={isPasswordType ? "password" : "text"}
                disabled={true}
                className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
              />
              <img
                src={toggleInputType}
                onClick={() => setIsPasswordType(!isPasswordType)}
                alt="toggle input type"
                className={tw`absolute bottom-[10px] right-[40px] cursor-pointer`}
              />
              <img
                src={isCopiedAccessKey ? copiedIcon : copyIcon}
                onClick={() => handleCopy(apiData?.access_key, setIsCopiedAccessKey)}
                alt="copy icon"
                className={tw`absolute bottom-[10px] right-[10px] w-5 cursor-pointer`}
              />
            </div>
            <div className={tw`relative`}>
              <p>Secret Key</p>
              <input
                defaultValue={apiData?.secret_key}
                type={isPasswordType2 ? "password" : "text"}
                disabled={true}
                className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
              />
              <img
                src={toggleInputType}
                onClick={() => setIsPasswordType2(!isPasswordType2)}
                alt="toggle input type"
                className={tw`absolute bottom-[10px] w-5 right-[40px] cursor-pointer`}
              />
              <img
                src={isCopiedSecretKey ? copiedIcon : copyIcon}
                onClick={() => handleCopy(apiData?.secret_key, setIsCopiedSecretKey)}
                alt="copy icon"
                className={tw`absolute bottom-[10px] right-[10px] cursor-pointer`}
              />
            </div>
          </div>
          <div className={tw`flex gap-x-8 mt-4`}>
            <div className={tw`flex gap-x-8`}>
              <p>Test Mode</p>
              <UnControlSwitch
                value={apiData?.is_active}
                onChange={handleToggleIsActive}
              />
            </div>
            <div className={tw`flex gap-x-8`}>
              <p>Active Status</p>
              <UnControlSwitch
                value={apiData?.is_test}
                onChange={handleToggleIsTest}
              />
            </div>
          </div>
          <div className={tw`w-full flex justify-between`}>
            <div className={tw`w-[150px] mt-6`}>
              <Button
                label={"Generate New Key"}
                onClick={handleCreateNewAPI}
                isLoading={isPostLoading}
              />
            </div>
          </div>
        </div>
      </Card>
      {/* <Card title='Documentations'>
        <p>Coming Soon</p>
      </Card> */}
    </>
  );
};

export default APIIntegration;
